import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ApiService } from 'src/app/Services/api.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';

@Component({
  selector: 'app-alert-configuration',
  templateUrl: './alert-configuration.component.html',
  styleUrls: ['./alert-configuration.component.css']
})
export class AlertConfigurationComponent implements OnInit {

  public userData;

  public create:boolean=false;
  public alertForm:FormGroup;
  public reportForm:FormGroup;
  public notificationObj={};

  constructor(public api: ApiService,
    public swal: SweetAlert,
    public storage: StorageService,
    public fb: FormBuilder) { 
      this.userData = this.storage.get('userInfo')
  }

  ngOnInit(): void {
    this.addNotificationForm();
    this.getNotificationList();
  }
  addNotificationForm(){
    this.alertForm=this.fb.group({
      sms:false,
      call:false,
      email:false,
      app:false,
    });
    this.reportForm=this.fb.group({
      overspeed:false,
      geofence:false,
      sos:false,
    });
  }
/* get notification data*/
  getNotificationList() {
    const obj = {
      orgID: this.userData.orgID
    };
    this.api.transportManagerNotificationList(obj).then((res: any) => {
      if (res.status == 'success') {
        this.notificationObj = res.data[0];
        console.log(this.notificationObj);
      }
      if(Object.keys(this.notificationObj).length>0) this.setNotificationValue();
      else this.create=true;
    }).catch((err) => {
      console.log(err);
    });
  }
/* patch notification values */
  setNotificationValue(){
    if(this.notificationObj && this.notificationObj["alertConfiguration"]) this.alertForm.setValue(this.notificationObj["alertConfiguration"]);
    if(this.notificationObj && this.notificationObj["reportConfiguration"]) this.reportForm.setValue(this.notificationObj["reportConfiguration"]);
  }

  onSubmit(){
    let obj={
      orgID:this.userData.orgID,
      alertConfiguration:this.alertForm.value,
      reportConfiguration:this.reportForm.value,
    };
    console.log(obj);
    if(this.create==true) this.createNotification(obj);
    else this.updateNotification(obj);
  }
  updateNotification(obj){
    obj["notificationID"]=this.notificationObj["notificationID"];
    this.api.transportManagerNotificationUpdate(obj).then((res: any) => {
      if (res.status == 'success') {
        this.swal.swalFunction(res.status, res.status, res.message, 2000);
      }
      if (res.status == 'failure') {
        this.swal.swalFunction('error', res.status, res.message, 3000);
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  createNotification(obj){
    console.log(obj);
    this.api.transportManagerNotificationCreate(obj).then((res: any) => {
      if (res.status == 'success') {
        this.swal.swalFunction(res.status, res.status, res.message, 2000);
        this.getNotificationList();
      }
      if (res.status == 'failure') {
        this.swal.swalFunction('error', res.status, res.message, 3000);
      }
    }).catch((err) => {
      console.log(err);
    });
  }

}
